export const formatPhone = str => {
  const clean = ('' + str).replace(/\D/g, '');
  const match = clean.match(/^(\d{3})(\d{1,3})?(\d{1,4})?(\d{0,5})/)

  if (!match) {
    return clean ? `(${clean}` : ''
  } else if (match[3]) {
    return `(${match[1]}) ${match[2]}-${match[3]}${match[4]}`
  } else if (match[2]) {
    return `(${match[1]}) ${match[2]}`
  } else {
    return `(${match[1]}) `
  }
}

export const cleanPhone = phone => {
  return phone.replace(/\D/g, '')
}